import { IFormState } from '../types/calculator';

/**
 * TODO оставлю пока как fallback-значения, чтобы не опираться на фичатогл. При рефакторинге - выпилить
 * */
export const DEFAULT_FORM_STATE = {
  region: '1',
  loanTerm: 30,
} as IFormState;
